var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(function () {
    angular
        .module('QMC.Aufgaben', [])
        .config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('tasks', {
            url: '/tasks',
            templateUrl: qmcBase + '/Aufgaben/List',
            controller: 'AufgabenListController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    function () {
                        console.log('Current State: Tasks');
                    }
                ]
            }
        })
            .state('tasksdetail', {
            url: '/tasks/:id',
            templateUrl: qmcBase + '/Aufgaben/List',
            controller: 'AufgabenListController',
            controllerAs: 'vm',
            resolve: {
                data: [
                    function () {
                        console.log('Current State: Tasks Detail');
                    }
                ]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        var HttpProvider = /** @class */ (function () {
            function HttpProvider() {
            }
            HttpProvider.configureHttpProvider = function ($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            };
            return HttpProvider;
        }());
        Task.HttpProvider = HttpProvider;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
(function () {
    angular.module('QMC.Aufgaben')
        .config(['$httpProvider', QMC.Task.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        var TaskService = /** @class */ (function (_super) {
            __extends(TaskService, _super);
            function TaskService($http, $q) {
                var _this = _super.call(this, $http, $q) || this;
                _this.$http = $http;
                _this.$q = $q;
                _this.modulePath = '/Task';
                return _this;
            }
            TaskService.prototype.getTaskList = function (maxDays) {
                return _super.prototype.get.call(this, this.modulePath, { maxDays: maxDays }, function (data) {
                    return data;
                });
            };
            TaskService.prototype.getTask = function (id) {
                return _super.prototype.getItem.call(this, this.modulePath + '/' + id, {}, function (data) {
                    return data;
                });
            };
            TaskService.prototype.getTaskWv = function () {
                return _super.prototype.getItem.call(this, this.modulePath + '/WvModel', {}, function (data) {
                    return data;
                });
            };
            TaskService.prototype.postTask = function (data) {
                return _super.prototype.post.call(this, this.modulePath, data).then(function (d) {
                    return d;
                });
            };
            TaskService.prototype.putTask = function (id, data) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id, data).then(function (data) {
                    return data;
                });
            };
            TaskService.prototype.setFinishedState = function (id, finishedState, finishDate) {
                return _super.prototype.put.call(this, this.modulePath + '/' + id + '/SetFinished/' + finishedState + "?finishDate=" + finishDate, null).then(function (data) {
                    return data;
                });
            };
            TaskService.prototype.deleteTask = function (id) {
                return _super.prototype.delete.call(this, this.modulePath + '/' + id).then(function (data) { return data; });
            };
            TaskService = __decorate([
                QMC.Service('QMC.Aufgaben', 'AufgabenService'),
                QMC.Inject('$http', '$q')
            ], TaskService);
            return TaskService;
        }(QMC.Common.BaseService));
        Task.TaskService = TaskService;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        var AufgabenListController = /** @class */ (function () {
            /**
             * Creates an instance of AufgabenListController.
             * @param {TaskService} taskService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {*} userService
             * @param {any} $state
             * @param {any} $scope
             * @param {any} $timeout
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberof AufgabenListController
             */
            function AufgabenListController($location, taskService, $qui, clientService, userService, $state, $scope, $timeout, lng, permissionService) {
                var _this = this;
                this.$location = $location;
                this.taskService = taskService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.userService = userService;
                this.$state = $state;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.lng = lng;
                this.permissionService = permissionService;
                this.newView = true;
                ////// permissions
                this.ui = new QMC.Task.UserInterface();
                this.allowTableExport = false;
                this.finishedTaskDays = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                this.lastSearchDays = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                ////// Form
                this.ignoreTaskModalCloseAction = false;
                this.callbacks = { onNew: function (form) { return _this.createTask(form); }, onEdit: function (form) { return _this.updateTask(form); } };
                $qui.init($qui.getSectionColor($location.path()), function () {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                    this.forbidden = true;
                    return;
                }
                if (this.newView)
                    return;
                this.initBase();
            }
            AufgabenListController.prototype.changeView = function () {
                if (!this.newView)
                    this.initBase();
            };
            AufgabenListController.prototype.initBase = function () {
                var _this = this;
                //ObjectType: WorklistItem
                this.permissionService.getPermissionsByObjectTypes([840501, 840508]).then(function (data) {
                    _this.delete = data[0].delete;
                    _this.new = data[0].new;
                    _this.modify = data[0].modify;
                    _this.allowTableExport = data[0].print;
                    _this.permissions = { base: data[0], document: data[1] };
                    _this.$timeout(function () {
                        _this.init();
                    });
                    _this.getWvs();
                    _this.$qui.getTableAutoload(_this.userService).then(function (ltd) {
                        _this.shouldLoadTableData = ltd;
                        _this.userService.getUserSettings(["TASK.FINISHEDTASKSDAYS"]).then(function (data) {
                            if (data[0].value !== "")
                                _this.finishedTaskDays = parseFloat(data[0].value);
                            if (_this.shouldLoadTableData) {
                                _this.getData();
                                _this.events();
                            }
                        });
                    });
                    _this.$scope.$on('$locationChangeStart', function () {
                        // delete interval if page is left
                        clearInterval(_this.interval);
                    });
                    if (_this.$state.params.id !== (null || undefined)) {
                        _this.editTask({ objectId: _this.$state.params.id });
                        if (_this.$state.history[0] && _this.$state.history[0].name !== _this.$state.current.name) {
                            $('#taskModal').on('hidden.bs.modal', function () {
                                if (!_this.ignoreTaskModalCloseAction)
                                    _this.goBack();
                            });
                        }
                    }
                });
            };
            AufgabenListController.prototype.getData = function () {
                this.getTasks();
            };
            /////////////// DISPLAY LOGIC ///////////////
            AufgabenListController.prototype.init = function () {
                if (localStorage.getItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED) !== null) {
                    this.hideFinished = localStorage.getItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED) === 'true';
                }
                this.promptOptions = {
                    title: "Aufgabe",
                    yesNo: true,
                    icon: "qm-icon-check",
                    text: ""
                };
            };
            AufgabenListController.prototype.events = function () {
                var _this = this;
                this.$scope.$watch('vm.finishedTaskDays', function () {
                    if (_this.lastSearchDays !== _this.finishedTaskDays && !_this.loading) {
                        if (_this.finishedTaskDays < 0)
                            _this.finishedTaskDays = 0;
                        _this.lastSearchDays = _this.finishedTaskDays;
                        _this.getTasks();
                    }
                });
            };
            AufgabenListController.prototype.goBack = function () {
                this.$state.go(this.$state.history[0].name, this.$state.history[0].params);
            };
            AufgabenListController.prototype.toggleShowFinished = function () {
                this.hideFinished = !this.hideFinished;
                localStorage.setItem(QMC.Common.LocalStorageConstants.TASK_LIST_HIDE_FINISHED, this.hideFinished.toString());
            };
            /////////////// SERVICE FUNCTIONS ///////////////
            AufgabenListController.prototype.getTasks = function () {
                var _this = this;
                this.filteredList = [];
                this.tasks = [];
                this.loading = true;
                this.taskService.getTaskList(Math.round(this.finishedTaskDays)).then(function (data) {
                    _this.lastSearchDays = _this.finishedTaskDays;
                    _this.tasks = data;
                    _this.loading = false;
                    _this.filteredList = angular.copy(data);
                    if (_this.hideFinished) {
                        _this.filteredList = _this.filteredList.filter(function (obj) {
                            return obj.isFinished === false;
                        });
                    }
                    //format strings for card view:
                    for (var _i = 0, _a = _this.filteredList; _i < _a.length; _i++) {
                        var element = _a[_i];
                        if (!element.isFinished)
                            element.dateFinished = null;
                        if (element.priorityId !== null)
                            element.priorityString = _this.lng.translate(20014013, 'Priorität') + ": " + element.priority;
                        //this.filteredList[i].dateCreatedString = this.lng.translate(20000063, 'Erstellt am') + ": " + moment(this.filteredList[i].dateCreated).format("DD.MM.YYYY");
                        if (element.isFinished)
                            element.dateFinishedString = _this.lng.translate(20014015, 'Erledigt am') + ": " + moment(element.dateFinished).format("DD.MM.YYYY");
                        if (element.dateToFinishTill !== null)
                            element.dateToFinishString = _this.lng.translate(20014009, 'Frist') + ": " + moment(element.dateToFinishTill).format("DD.MM.YYYY");
                        element.hideMod =
                            element.isUserAuthor && !element.isFinished;
                    }
                    _this.ui.taskTable.data = _this.filteredList;
                    _this.$qui.functionWaiter("ui.createTable", _this);
                    setTimeout(function () {
                        $(".action-padding-top").css('padding-top', '.25em');
                    }, 500);
                });
            };
            AufgabenListController.prototype.createTask = function (form) {
                var _this = this;
                if (form.participantIds === null || form.participantIds === undefined) {
                    form.participantIds = [];
                }
                this.loading = true;
                this.taskService.postTask(form).then(function () {
                    _this.ui.notify(_this.ui.successNote);
                    _this.init();
                    _this.getTasks();
                    _this.loading = false;
                });
            };
            AufgabenListController.prototype.updateTask = function (task) {
                var _this = this;
                this.taskService.putTask(task.objectId, task).then(function (data) {
                    _this.ui.notify(_this.ui.successNote);
                    _this.getTasks();
                });
            };
            AufgabenListController.prototype.editTask = function (task) {
                var _this = this;
                this.loading = true;
                this.taskService.getTask(task.objectId).then(function (data) {
                    data.participantIds = [];
                    data.participants.forEach(function (participant) {
                        data.participantIds.push(participant.id);
                    });
                    data.participants = data.participants.sort(function (a, b) { return a.fullName.localeCompare(b.fullName); });
                    data.taskDocumentObjectType = 840508;
                    _this.formActions.open(data);
                    _this.loading = false;
                });
            };
            AufgabenListController.prototype.deleteTask = function (item) {
                var _this = this;
                this.promptOptions.text = this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?');
                this.promptOptions.itemText = item.taskName;
                if ($('#taskModal').is(':visible')) {
                    this.ignoreTaskModalCloseAction = true;
                    $('#taskModal').modal('hide');
                    setTimeout(function () {
                        _this.ignoreTaskModalCloseAction = false;
                    }, 500);
                }
                if (item.isFinished) {
                    QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                        if (data)
                            _this.taskService.deleteTask(item.objectId).then(function () {
                                _this.getTasks();
                                _this.ui.notify(_this.ui.deleteNote);
                                _this.goBackMaybe();
                            });
                        else
                            _this.goBackMaybe();
                    });
                }
                else {
                    QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                        if (data)
                            _this.taskService.setFinishedState(item.objectId, true, moment(new Date()).format("DD.MM.YYYY").toString()).then(function () {
                                _this.taskService.deleteTask(item.objectId).then(function () {
                                    _this.getTasks();
                                    _this.ui.notify(_this.ui.deleteNote);
                                    $('#editTaskModal').unbind('hidden.bs.modal').off('hidden.bs.modal');
                                    _this.goBackMaybe();
                                });
                            });
                        else
                            _this.goBackMaybe();
                    });
                }
            };
            AufgabenListController.prototype.goBackMaybe = function () {
                if (this.$state.params.id !== (null || undefined)) {
                    if (this.$state.history[0] && this.$state.history[0].name !== this.$state.current.name) {
                        this.goBack();
                    }
                }
            };
            AufgabenListController.prototype.finishTask = function (form) {
                var _this = this;
                this.promptOptions.itemText = form.taskName;
                this.promptOptions.text = this.lng.translate(20014023, 'Aufgabe wirklich als erledigt markieren?');
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.taskService.setFinishedState(form.objectId, true, Date()).then(function () {
                            _this.$qui.notify(_this.$qui.successNote);
                            _this.getTasks();
                        });
                });
            };
            AufgabenListController.prototype.undoTask = function (form) {
                var _this = this;
                this.promptOptions.itemText = form.taskName;
                this.promptOptions.text = this.lng.translate(20014025, 'Aufgabe wirklich zurücksetzen?');
                QMC.Common.Utilities.confirm(this.promptOptions, function (data) {
                    if (data)
                        _this.taskService.setFinishedState(form.objectId, false, null).then(function () {
                            _this.ui.notify(_this.ui.successNote);
                            _this.getTasks();
                        });
                });
            };
            AufgabenListController.prototype.getWvs = function () {
                var _this = this;
                this.taskService.getTaskWv().then(function (data) {
                    _this.wv = data;
                    var clients = [];
                    _this.clientService.getAllPersonLists().then(function (data) {
                        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                            var element = data_1[_i];
                            clients.push({
                                value: element.objectId,
                                text: element.name + ' (' + _this.lng.translate(20000292, 'Verteiler') + ')'
                            });
                        }
                        _this.clientService.getEmployeeList().then(function (data) {
                            for (var _i = 0, data_2 = data; _i < data_2.length; _i++) {
                                var element = data_2[_i];
                                clients.push({
                                    value: element.objectId,
                                    text: element.displayTitle
                                });
                            }
                            _this.maps = {
                                category: _this.wv.categoryWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                priority: _this.wv.priorityWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                executionType: _this.wv.executionTypeWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                participant: clients,
                            };
                        });
                    });
                });
            };
            AufgabenListController = __decorate([
                QMC.Controller('QMC.Aufgaben', 'AufgabenListController'),
                QMC.Inject('$location', 'AufgabenService', '$qui', 'KlientService', 'UserService', '$state', '$scope', '$timeout', 'QmcLanguageService', 'QmcPermissionService')
            ], AufgabenListController);
            return AufgabenListController;
        }());
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        var TaskDirective = /** @class */ (function () {
            function TaskDirective(taskService, clientService, userService, $qui, lng, permissionService, $timeout) {
                var _this = this;
                this.taskService = taskService;
                this.clientService = clientService;
                this.userService = userService;
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.templateUrl = './Aufgaben/';
                this.replace = true;
                this.scope = {
                    tasks: '@',
                    onCompleteTodo: '@',
                    forbidden: '@'
                };
                this.controller = ['$scope', function (scope) {
                        scope.ui = new Task.UserInterface();
                    }];
                this.link = function (scope) {
                    if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                        scope.forbidden = true;
                        return;
                    }
                    scope.callbacks = { onNew: function (form) { return scope.createTask(form); }, onEdit: function (form) { return scope.updateTask(form); } };
                    scope.vm = scope;
                    scope.forbidden = false;
                    scope.taskDocumentObjectType = '840508';
                    scope.objectType = '840501';
                    //ObjectType: WorklistItem
                    _this.permissionService.getPermissionsByObjectTypes([scope.objectType, scope.taskDocumentObjectType]).then(function (data) {
                        scope.deletePermission = data[0].delete;
                        scope.new = data[0].new;
                        scope.modify = data[0].modify;
                        scope.permissions = {
                            base: data[0],
                            document: data[1]
                        };
                    });
                    _this.userService.getUserSettings(["TASK.FINISHEDTASKSDAYS"]).then(function (data) {
                        scope.finishedTaskDays = "" ? scope.finishedTaskDays : parseFloat(data[0].value);
                        scope.tasks = scope.getTasks();
                    });
                    scope.promptOptions = {
                        title: "Aufgabe",
                        yesNo: true,
                        icon: "qm-icon-check",
                        text: _this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?'),
                    };
                    scope.loading = true;
                    scope.onCompleteTodo = function (item) {
                        scope.putToFinish(item);
                    };
                    if (document.getElementById("permissions").getAttribute("task").toLocaleLowerCase() !== "true") {
                        console.log("No rights to see module task");
                        scope.forbidden = true;
                        return;
                    }
                    /////////////// DISPLAY LOGIC ///////////////
                    scope.getDetailModal = function (obj) {
                        scope.loading = true;
                        _this.taskService.getTask(obj.objectId).then(function (data) {
                            scope.selectedTask = data;
                            scope.selectedTask.participantIds = [];
                            if (scope.selectedTask.dateFinished)
                                scope.selectedTask.dateFinished = _this.$qui.createDateFromString(scope.selectedTask.dateFinished);
                            else
                                scope.selectedTask.dateFinished = new Date();
                            data.participants.forEach(function (participant) {
                                scope.selectedTask.participantIds.push(participant.objectId);
                            });
                            scope.openEditModal();
                            scope.loading = false;
                        });
                    };
                    scope.openNewTaskModal = function () {
                        scope.formActions.new();
                    };
                    scope.openEditModal = function () {
                        var form = angular.copy(scope.selectedTask);
                        form.taskDocumentObjectType = 840508;
                        scope.formActions.open(form);
                    };
                    /////////////// SERVICE FUNCTIONS ///////////////
                    scope.createTask = function (form) {
                        if (form.participantIds === (null && undefined))
                            form.participantIds = [];
                        scope.loading = true;
                        _this.taskService.postTask(form).then(function () {
                            _this.$qui.notify(_this.$qui.successNote);
                            scope.tasks = scope.getTasks();
                            scope.loading = false;
                        });
                    };
                    scope.updateTask = function (task) {
                        scope.loading = true;
                        _this.taskService.putTask(task.objectId, task).then(function () {
                            _this.$qui.notify(_this.$qui.successNote);
                        }).finally(function () {
                            scope.loading = false;
                            scope.tasks = scope.getTasks();
                        });
                    };
                    scope.deleteTask = function (task) {
                        scope.promptOptions.text = _this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?');
                        scope.promptOptions.itemText = task.taskName;
                        if (task.isFinished) {
                            QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                                if (data) {
                                    scope.loading = true;
                                    _this.taskService.deleteTask(task.objectId).then(function () {
                                        scope.tasks = scope.getTasks();
                                        _this.$qui.notify(_this.$qui.deleteNote);
                                    }).finally(function () {
                                        scope.loading = false;
                                    });
                                }
                            });
                        }
                        else {
                            QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                                if (data) {
                                    scope.loading = true;
                                    _this.taskService.setFinishedState(task.objectId, true, moment(new Date()).format("DD.MM.YYYY").toString()).then(function (data) {
                                        _this.taskService.deleteTask(task.objectId).then(function () {
                                            scope.tasks = scope.getTasks();
                                            _this.$qui.notify(_this.$qui.deleteNote);
                                        }).finally(function () {
                                            scope.loading = false;
                                        });
                                    });
                                }
                            });
                        }
                    };
                    scope.putToFinish = function (item) {
                        _this.taskService.setFinishedState(item.objectId, item.isFinished, item.dateFinished).then(function (data) {
                            _this.$qui.notify(_this.$qui.successNote);
                            scope.tasks = scope.getTasks();
                        });
                    };
                    scope.finishTask = function (form) {
                        scope.promptOptions.itemText = form.taskName;
                        scope.promptOptions.text = _this.lng.translate(20014023, 'Aufgabe wirklich als erledigt markieren?');
                        QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                            if (data)
                                _this.taskService.setFinishedState(form.objectId, true, Date()).finally(function () {
                                    scope.tasks = scope.getTasks();
                                });
                        });
                    };
                    scope.undoTask = function (form) {
                        scope.promptOptions.text = _this.lng.translate(20014025, 'Aufgabe wirklich zurücksetzen?');
                        scope.promptOptions.itemText = form.taskName;
                        QMC.Common.Utilities.confirm(scope.promptOptions, function (data) {
                            if (data)
                                _this.taskService.setFinishedState(form.objectId, false, null).finally(function () {
                                    scope.tasks = scope.getTasks();
                                });
                        });
                    };
                    scope.getWvs = function () {
                        _this.taskService.getTaskWv().then(function (wvData) {
                            var clients = [];
                            _this.clientService.getAllPersonLists().then(function (data) {
                                for (var _i = 0, data_3 = data; _i < data_3.length; _i++) {
                                    var element = data_3[_i];
                                    clients.push({
                                        value: element.objectId,
                                        text: element.name + ' (' + _this.lng.translate(20000292, 'Verteiler') + ')'
                                    });
                                }
                                _this.clientService.getEmployeeList().then(function (data) {
                                    for (var _i = 0, data_4 = data; _i < data_4.length; _i++) {
                                        var element = data_4[_i];
                                        clients.push({
                                            value: element.objectId,
                                            text: element.displayTitle
                                        });
                                    }
                                    scope.maps = {
                                        category: wvData.categoryWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                        priority: wvData.priorityWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                        executionType: wvData.executionTypeWvList.map(function (obj) { return ({ value: obj.objectId, text: obj.name }); }),
                                        participant: clients,
                                    };
                                });
                            });
                        });
                    };
                    scope.getTasks = function () {
                        scope.loading = true;
                        return _this.taskService.getTaskList(Math.round(scope.finishedTaskDays)).then(function (data) {
                            scope.loading = false;
                            return data;
                        });
                    };
                    scope.getWvs();
                };
            }
            TaskDirective = __decorate([
                QMC.Directive('QMC.Aufgaben', 'qmTasks', ['AufgabenService', 'KlientService', 'UserService', '$qui', 'QmcLanguageService', 'QmcPermissionService', '$timeout'])
            ], TaskDirective);
            return TaskDirective;
        }());
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        var TaskFormDirective = /** @class */ (function () {
            function TaskFormDirective($qui, $timeout) {
                var _this = this;
                this.$qui = $qui;
                this.$timeout = $timeout;
                this.restrict = 'E';
                this.templateUrl = './Aufgaben/Form';
                this.replace = true;
                this.scope = {
                    permissions: '=',
                    callbacks: '&',
                    actions: '=',
                    modalId: '=?',
                    maps: '=?',
                    loading: '=?'
                };
                this.controller = ['$scope', function (scope) {
                        var _a;
                        scope.vm = scope;
                        scope.ui = new Task.UserInterface();
                        scope.modalId = (_a = scope.modalId) !== null && _a !== void 0 ? _a : 'taskModal_' + Math.random().toString(36).substr(2, 9);
                    }];
                this.link = function (scope) {
                    var initModal = function () {
                        $("#" + scope.modalId).modal('show');
                        if (!scope.maps) {
                            setTimeout(function () { initModal(); }, 500);
                            console.warn('No maps ready, can not create task form');
                            return;
                        }
                        _this.$qui.functionWaiter('ui.createDirective', scope);
                        _this.$qui.functionWaiter('ui.createForm', scope);
                        _this.$qui.waitForEl("#standardTabButton_" + scope.modalId, function () {
                            $("#standardTabButton_" + scope.modalId).click();
                        });
                    };
                    scope.actions = {
                        open: function (form) {
                            scope.form = angular.copy(form);
                            scope.formState = 'edit';
                            initModal();
                        },
                        new: function (form) {
                            scope.formInvalid = true;
                            if (!form) {
                                var newGuidId = _this.$qui.generateGuid();
                                form = {
                                    id: newGuidId,
                                    objectId: newGuidId,
                                    mainTaskId: newGuidId,
                                    objectType: 840501,
                                    taskDocumentObjectType: 840508,
                                    checked: false,
                                    isFinished: false,
                                    authorName: null,
                                    taskDescription: null,
                                    taskName: null,
                                    executionType: null,
                                    executionTypeId: QMC.Common.Constants.EXECUTION_TYPE_SINGLE_ID,
                                    dateCreated: new Date(),
                                    dateToFinishTill: null,
                                    dateFinished: null,
                                    categoryId: null,
                                    priorityId: null,
                                    priority: '',
                                    participantIds: [],
                                    participants: [],
                                    isUserAuthor: true
                                };
                                form.participantIds.push($('#session').data().personId);
                            }
                            scope.form = angular.copy(form);
                            scope.formState = 'new';
                            initModal();
                        }
                    };
                    scope.$watch('form', function () {
                        _this.$timeout(function () {
                            scope.formInvalid = $("#" + scope.modalId).find("#baseDataTab_" + scope.modalId).find('.ng-invalid').length > 0;
                        });
                    }, true);
                    scope.getCategoryList = function () {
                        return scope.maps.category;
                    };
                    scope.getPriorityList = function () {
                        return scope.maps.priority;
                    };
                    scope.getExecutionTypeList = function () {
                        return scope.maps.executionType;
                    };
                    scope.getClients = function () {
                        return scope.maps.participant;
                    };
                    scope.onSave = function (form, state) {
                        if (state === 'new')
                            scope.callbacks().onNew(form);
                        if (state === 'edit')
                            scope.callbacks().onEdit(form);
                        $("#" + scope.modalId).modal('hide');
                    };
                };
            }
            TaskFormDirective = __decorate([
                QMC.Directive('QMC.Aufgaben', 'qmTaskForm', ['$qui', '$timeout'])
            ], TaskFormDirective);
            return TaskFormDirective;
        }());
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Task;
    (function (Task) {
        /**
         * Task UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        var UserInterface = /** @class */ (function (_super) {
            __extends(UserInterface, _super);
            function UserInterface() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                /**
                 * Task table
                 * @memberOf UserInterface
                 */
                _this.taskTable = {
                    "config": {
                        "defaultSort": "dateToFinishTill",
                    },
                    "table": {
                        "Aufgabe": {
                            "label": "taskName",
                            "dType": "string",
                            "lngTag": "20014007",
                        },
                        "Frist": {
                            "label": "dateToFinishTill",
                            "dType": "Date",
                            "lngTag": "20014009",
                        },
                        "Autor": {
                            "label": "authorName",
                            "dType": "string",
                            "lngTag": "20000062",
                        },
                        "Erledigungstyp": {
                            "label": "executionType",
                            "dType": "string",
                            "lngTag": "20014014",
                        },
                        "Priorität": {
                            "label": "priority",
                            "dType": "string",
                            "lngTag": "20014013",
                        },
                        "Erledigt am": {
                            "label": "dateFinished",
                            "dType": "Date",
                            "lngTag": "20014015",
                        },
                        "Erledigt": {
                            "label": "isFinished",
                            "dType": "Bool",
                            "lngTag": "20000120",
                            "invisible": true
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-check  green",
                                "click": "finishTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Als erledigt markieren",
                                "lngTag": "20014018",
                                "permission": "modify",
                                "events": {
                                    "hide": "isFinished",
                                },
                            }, {
                                "icon": "qm-icon-navigate_cross red",
                                "click": "undoTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Erledigung aufheben",
                                "lngTag": "20014024",
                                "permission": "modify",
                                "events": {
                                    "hide": "!isFinished",
                                },
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editTask",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#taskModal",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTask",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isUserAuthor"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa qm-icon-clipboard_check_edit"
                        },
                        "text": {
                            "label": "taskName",
                            "dType": "string",
                            "lngTag": "20014007",
                        },
                        "subtext": [{
                                "label": "dateFinishedString",
                                "dType": "string",
                            }, {
                                "label": "executionType",
                                "dType": "string",
                            }, {
                                "label": "priorityString",
                                "dType": "string",
                            }, {
                                "label": "dateToFinishString",
                                "dType": "string"
                            }],
                        "toggle": {
                            "label": "isFinished"
                        },
                        "buttons": [{
                                "icon": "qm-icon-check  green",
                                "click": "finishTask",
                                "tooltip": "Als erledigt markieren",
                                "lngTag": "20014018",
                                "events": {
                                    "hide": "isFinished",
                                },
                            }, {
                                "icon": "qm-icon-navigate_cross red",
                                "click": "undoTask",
                                "tooltip": "Erledigung aufheben",
                                "lngTag": "20014024",
                                "events": {
                                    "hide": "!isFinished",
                                },
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editTask",
                                "openModal": "true",
                                "targetModal": "#taskModal",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTask",
                                "permission": "delete",
                                "tooltip": "Löschen",
                                "lngTag": "20000002"
                            }]
                    },
                    "data": null,
                };
                /**
                 * Task form
                 * @memberOf UserInterface
                 */
                _this.taskForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: "20014008"
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select2",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '87fc153c-3f3b-4746-9b45-c857f017cf2b',
                            wvListData: 'wv.categoryWvList'
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select2",
                            lngTag: "20014013",
                            model: "priorityId",
                            dataSource: "getPriorityList",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '4ffc823f-6619-4d38-a5ec-7d86a5e1d28a',
                            wvListData: 'wv.priorityWvList'
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select2",
                            lngTag: "20014014",
                            model: "executionTypeId",
                            dataSource: "getExecutionTypeList",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: "20014021"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "CheckboxInline",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!(qmForm.dateToFinishTill)"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            lngTag: "20014010",
                            model: "participantIds",
                            dataSource: "getClients",
                            multiple: true,
                            id: "participantsTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eintragen ...",
                            placeholderTag: '20014019',
                            type: "Summernote",
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        put: "updateTask",
                        post: "createTask",
                        delete: "deleteTask"
                    }
                };
                return _this;
            }
            return UserInterface;
        }(QMC.Common.UserInterface));
        Task.UserInterface = UserInterface;
    })(Task = QMC.Task || (QMC.Task = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Task/qmc.task.js.map
